
import AnimationOverlay from '~/components/core/AnimationOverlay';
  export default {
    components: { AnimationOverlay },
    props: {
      title: "",
      shortDesc: "",
      showMapPerm: true,
      titleSpacing: {
        type: String,
        default: "mb-3"
      },
      subTitle: {
        type: String,
        default: ""
      }
    }
  }

